module.exports = __webpack_public_path__ + "assets/7af7472c4a3d80d2a7815afb7bebfe9c.mp3";